// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2LS2E","wrapper":"styles_wrapper__2Fi1i","defaultImageWrapper":"styles_defaultImageWrapper__11Q-J","uploadImage":"styles_uploadImage__3YRdH"};